import React from 'react'
import ReactDOM from "react-dom";
import CustomerRatingBar from 'shared-ui/src/components/molecules/Product/CustomerRating/Bar';
import { secureGetAttribute } from '../utils'

export const ID = 'customer-rating-bar'

export function renderCustomerRatingBar(selector = `#${ID}`) {
    const customerRatingBarInstances = Array.from(
        document.querySelectorAll(selector)
    );

    customerRatingBarInstances.forEach((element) => {
        const customerRating = parseInt(
            secureGetAttribute(element, "data-customer-rating") || 0,
            10
        );

        const ratingCount = parseInt(
            secureGetAttribute(element, "data-rating-count"),
            10
        );

        const size = secureGetAttribute(element, "data-size");

        ReactDOM.render(
            <CustomerRatingBar
                rating={customerRating}
                ratingCount={ratingCount}
                size={size}
            />,
            element
        );
    })
}

document.addEventListener('DOMContentLoaded', function() {
    renderCustomerRatingBar();
});
